import IdentityList from './IdentityList';
import IdentityShow from './IdentityShow';

export default {
  list: IdentityList,
  show: IdentityShow,
};
